import { FETCH_SOURCES } from "@colossus/contracts";
import type { FetchSource } from "@colossus/contracts";
import { BRING_BOTS } from "../leveling-switch.ts";
import { importSourceLabel } from "../import-source.ts";
import type { Locale } from "../locale.ts";

const UNREADABLE: readonly FetchSource[] = ["tatsu"];

export const DIRECT_IMPORT_SOURCES: readonly FetchSource[] = FETCH_SOURCES.filter(
  (source) => !UNREADABLE.includes(source) && BRING_BOTS.some((bot) => bot === source),
);

export const directImportBots = (locale: Locale): string =>
  new Intl.ListFormat(locale, { type: "conjunction" }).format(
    DIRECT_IMPORT_SOURCES.map(importSourceLabel),
  );
